// Display-name wire protocol — Phase 7 Block B.
//
// Shape-only module: types + builders. Same precedent as
// shared/combat-messages.ts and shared/expedition-messages.ts —
// the Envelope generic is inlined to avoid a circular import with
// shared/messages.ts (which re-exports the union extension below).

type Envelope<T extends string, P> = {
  type: T;
  ts: number;
  payload: P;
  seq?: number;
  eventId?: string;
};

// Client → Server. Player picks or changes their display name.
// Server validates (3-20 chars, alphanumeric + underscore + hyphen),
// writes to player.display_name, and pushes a `displayNameSet`
// durable on success.
export type ClientSetDisplayName = Envelope<"setDisplayName", { name: string }>;

// Server → Client (DURABLE). Sent to the player themselves AND
// broadcast ephemerally to every other client in the zone so peer
// nameplates update without waiting for the next snapshot.
export type ServerDisplayNameSet = Envelope<
  "displayNameSet",
  { playerId: string; displayName: string }
>;

export const buildSetDisplayNameMessage = (name: string): ClientSetDisplayName => ({
  type: "setDisplayName",
  ts: Date.now(),
  payload: { name },
});

export const buildDisplayNameSetMessage = (
  playerId: string,
  displayName: string,
): ServerDisplayNameSet => ({
  type: "displayNameSet",
  ts: Date.now(),
  payload: { playerId, displayName },
});
